import { User } from 'library/types';
import TextField from '@mui/material/TextField';
import { renderAutoCompleteLocaleText } from 'utils';
import Autocomplete from '@mui/material/Autocomplete';
import { gray } from 'providers/theme/themePrimitives';
import { svgIconClasses, useTheme } from '@mui/material';
import { GridRenderEditCellParams, useGridApiContext } from '@mui/x-data-grid-premium';

type Props = GridRenderEditCellParams & {
  users: User[];
};

const UserAutocompleteEditCell = ({ users, ...params }: Props) => {
  const theme = useTheme();
  const apiRef = useGridApiContext();

  const selectedUser = users.find((user) => user.id === params.value) ?? null;

  return (
    <Autocomplete
      fullWidth
      options={users}
      value={selectedUser}
      {...renderAutoCompleteLocaleText()}
      getOptionLabel={(option) => option?.nameSurname ?? ''}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      onChange={async (_, newValue) => {
        await apiRef.current.setEditCellValue({
          id: params.id,
          field: params.field,
          value: newValue?.id ?? null,
        });
      }}
      renderInput={(autocompleteParams) => (
        <TextField
          {...autocompleteParams}
          sx={{
            '& .MuiButtonBase-root': {
              border: 'none',
              backgroundColor: 'inherit',
              width: '2.25rem',
              height: '2.25rem',
              padding: '0.25rem',
              [`& .${svgIconClasses.root}`]: { fontSize: '1rem' },
              '&:hover': {
                backgroundColor: theme.palette.mode === 'light' ? gray[100] : gray[800],
              },
            },
          }}
        />
      )}
    />
  );
};

export default UserAutocompleteEditCell;
